import React from 'react';

import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import image from 'assets/images/homepage/feature_section.png';

import { openModal } from 'shared/components/Modals/reducer';

import Image from 'shared/components/Image';

import styles from './styles.module.scss';

const FeatureSection = ({ title, description, openModal }) => (
  <div className={styles.wrapper}>
    <div className={styles.imageContainer}>
      <Image src={image} width="100%" />
    </div>
    <div className={styles.right}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <div
        className={styles.button}
        onClick={() => openModal({ modalName: MODALS.SIGNUP })}>
        Get started, it's free!
      </div>
    </div>
  </div>
);

const mapStateToProps = state => ({});

const mapDispatchToProps = { openModal };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureSection);
